import { NODES_CHAIN } from "@/lib/homeExtras";
import { SectionHead, SHELL, Reveal } from "@/components/bits";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Programmable() {
    return (
        <section className="relative py-24 md:py-32" data-testid="programmable-section">
            <SHELL>
                <SectionHead
                    index="04"
                    label="PROGRAMMABLE CAPITAL"
                    title={"CAPITAL SHOULD BE PROGRAMMABLE."}
                    sub="VERA is designed around programmable financial relationships rather than static token representations. Capital moves as logic — allocated, routed, accounted and settled."
                />
                <Reveal>
                    <div className="glass-card p-8 md:p-12 relative overflow-hidden" data-testid="programmable-capital-diagram">
                        <div className="hidden md:flex items-center relative">
                            {NODES_CHAIN.map((n, i) => (
                                <div key={n.label} className="flex items-center flex-1 last:flex-none relative">
                                    <div
                                        className={`px-6 py-5 border font-mono text-xs tracking-[0.25em] whitespace-nowrap ${n.gold ? "border-vera-gold/60 text-vera-gold2 bg-vera-gold/10" : "border-vera-blue/40 text-[#A8D2FF] bg-vera-deep/60"}`}
                                        data-testid={`programmable-node-${n.label.toLowerCase()}`}
                                    >
                                        {n.label}
                                    </div>
                                    {i < NODES_CHAIN.length - 1 && (
                                        <div className="relative flex-1 h-px bg-white/10 mx-3 overflow-visible">
                                            <span
                                                className="absolute top-1/2 -mt-[3px] w-1.5 h-1.5 rounded-full bg-vera-gold2 shadow-[0_0_8px_#F3D18A] animate-[packet_3.2s_linear_infinite]"
                                                style={{ animationDelay: `${i * 0.64}s` }}
                                                aria-hidden="true"
                                            />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className="md:hidden flex flex-col gap-0 items-stretch">
                            {NODES_CHAIN.map((n, i) => (
                                <div key={n.label} className="flex flex-col items-start">
                                    <div className={`px-5 py-4 border font-mono text-[11px] tracking-[0.25em] ${n.gold ? "border-vera-gold/60 text-vera-gold2 bg-vera-gold/10" : "border-vera-blue/40 text-[#A8D2FF] bg-vera-deep/60"}`}>
                                        {n.label}
                                    </div>
                                    {i < NODES_CHAIN.length - 1 && <div className="w-px h-7 bg-white/10 ml-8" aria-hidden="true" />}
                                </div>
                            ))}
                        </div>
                    </div>
                </Reveal>
                <Reveal delay={0.1}>
                    <div className="flex flex-wrap items-center justify-between gap-4 mt-6">
                        <p className="font-mono text-[9px] tracking-[0.2em] text-vera-mut/60">INTERACTIVE CONCEPT — DEPLOY, ROUTE AND SETTLE AS RULES, NOT PAPERWORK</p>
                        <Link to="/architecture" data-testid="programmable-architecture-link" className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] text-vera-gold2 hover:text-vera-gold transition-colors">
                            SEE THE ARCHITECTURE <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" />
                        </Link>
                    </div>
                </Reveal>
            </SHELL>
        </section>
    );
}
